import apiRequest from "utils/ApiRequest/apiRequest.js";
import OnlySubscribersAlert from "../../OnlySubscribersAlert.js";
import Form from "components/Reusable/Form/Form.js";
import businessProfileFields, {
  BusinessProfileField,
} from "./businessProfileFormFields.tsx";
import { useContent } from "contexts/contentContext/contentContext.js";
import { useToasts } from "react-toast-notifications";
import { useUser } from "contexts/userContext/userContext.js";
import { useEffect, useState } from "react";
import { faHouseUser } from "@fortawesome/free-solid-svg-icons";
import { useRateLimitError } from "hooks/useRateLimitError.ts";
import "./BussinessProfile.scss";

const BussinessProfile = () => {
  const { getTextByKey } = useContent();
  const { addToast } = useToasts();
  const { getUserData, isBusiness, isPremium } = useUser();
  const [fields, setFields] = useState(businessProfileFields);
  const { isRateLimitError, showRateLimitError } = useRateLimitError();
  const disabledEditingByTopUser = getUserData().TopUserBrandingEnabled;

  const handleSubmit = async (body) => {
    const response = await apiRequest(
      "UserTemplates",
      "ReactSetUserBrandedHeaderInfo",
      { ...body, IsActive: true },
      "POST"
    );
    if (response.status === "success") {
      if (response.data) {
        addToast(getTextByKey("update-bussiness-info-success"), {
          appearance: "success",
        });
      }
    }

    if (response.status === "error") {
      isRateLimitError(response) && showRateLimitError();
    }
  };

  useEffect(() => {
    if (!getUserData().IsSubUser) {
      setFields((prev) => {
        return {
          Organization: {
            element: "customelement",
            fieldKey: "Organization",
            render: (props) => (
              <BusinessProfileField
                {...props}
                label="organization"
                icon={faHouseUser}
              />
            ),
          },
          ...prev,
        };
      });
    }
  }, [getUserData().IsSubUser]);

  // !disabledEditingByTopUser - available submition

  return (
    <>
      {!isBusiness() && !isPremium() && (
        <OnlySubscribersAlert
          text={"branding-business-profile-only-subscriber-text"}
        />
      )}
      <div
        className={`bussiness-profile-page${
          !isBusiness() && !isPremium() ? " view-only" : ""
        }`}
      >
        <Form
          fields={fields}
          onSubmit={handleSubmit}
          submitProps={{
            title: getTextByKey("save"),
          }}
          defaultValuesObj={{
            FacebookLink: getUserData().SocialMediaLinks.facebook,
            InstagramLink: getUserData().SocialMediaLinks.instagram,
            TwitterLink: getUserData().SocialMediaLinks.twitter,
            YoutubeLink: getUserData().SocialMediaLinks.youtube,
            VimeoLink: getUserData().SocialMediaLinks.vimeo,
            LinkedinLink: getUserData().SocialMediaLinks.linkedin,
            WhatsappLink: getUserData().SocialMediaLinks.whatsapp,
            WebsiteLink: getUserData().SocialMediaLinks.website,
            ContactByPhone: getUserData().ContactDetails.phone,
            ContactByEmail: getUserData().ContactDetails.email,
            Organization: getUserData().Organization,
          }}
        />
      </div>
    </>
  );
};

export default BussinessProfile;
